import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import Profil from '@/views/Profil.vue'
import Tupoksi from '@/views/Tupoksi.vue'
import Struktur from '@/views/Struktur.vue'
import Visi from '@/views/Visi.vue'
import Berita from '@/views/Berita.vue'
import DetailBerita from '@/views/DetailBerita.vue'
import Pengumuman from '@/views/Pengumuman.vue'
import Dokumen from '@/views/Dokumen.vue'
import Foto from '@/views/Foto.vue'
import Video from '@/views/Video.vue'
import Sekretariat from '@/views/Sekretariat.vue'
import ProdukHukum from '@/views/ProdukHukum.vue'
import Data from '@/views/Data.vue'
import Pejabat from '@/views/Pejabat.vue'
import Sosial from '@/views/Sosial.vue'
import Usaha from '@/views/Usaha.vue'
import Kelembagaan from '@/views/Kelembagaan.vue'
import Pemerintahan from '@/views/Pemerintahan.vue'
import KerjaSama from '@/views/KerjaSama.vue'
import Ekonomi from '@/views/Ekonomi.vue'
import Perkreditan from '@/views/Perkreditan.vue'
import Lembaga from '@/views/Lembaga.vue'
import Keuangan from '@/views/Keuangan.vue'
import Sarana from '@/views/Sarana.vue'
import Ttg from '@/views/Ttg.vue'
import Budaya from '@/views/Budaya.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/profil',
    name: 'profil',
    component: Profil
  },
  {
    path: '/tupoksi',
    name: 'tupoksi',
    component: Tupoksi
  },
  {
    path: '/struktur',
    name: 'struktur',
    component: Struktur
  },
  {
    path: '/visi',
    name: 'visi',
    component: Visi
  },
  {
    path: '/pejabat',
    name: 'pejabat',
    component: Pejabat
  },
  {
    path: '/sekretariat',
    name: 'sekretariat',
    component: Sekretariat
  },
  {
    path: '/sosial',
    name: 'sosial',
    component: Sosial
  },
  {
    path: '/usaha',
    name: 'usaha',
    component: Usaha
  },
  {
    path: '/kelembagaan',
    name: 'kelembagaan',
    component: Kelembagaan
  },
  {
    path: '/pemerintahan',
    name: 'pemerintahan',
    component: Pemerintahan
  },
  {
    path: '/kerja_sama',
    name: 'kerja_sama',
    component: KerjaSama
  },
  {
    path: '/ekonomi',
    name: 'ekonomi',
    component: Ekonomi
  },
  {
    path: '/perkreditan',
    name: 'perkreditan',
    component: Perkreditan
  },
  {
    path: '/lembaga',
    name: 'lembaga',
    component: Lembaga
  },
  {
    path: '/keuangan',
    name: 'keuangan',
    component: Keuangan
  },
  {
    path: '/sarana',
    name: 'sarana',
    component: Sarana
  },
  {
    path: '/ttg',
    name: 'ttg',
    component: Ttg
  },
  {
    path: '/budaya',
    name: 'budaya',
    component: Budaya
  },
  {
    path: '/berita',
    name: 'berita',
    component: Berita
  },
  {
    path: '/detail_berita',
    name: 'detail_berita',
    component: DetailBerita
  },
  {
    path: '/pengumuman',
    name: 'pengumuman',
    component: Pengumuman
  },
  {
    path: '/dokumen',
    name: 'dokumen',
    component: Dokumen
  },
  {
    path: '/data',
    name: 'data',
    component: Data
  },
  {
    path: '/produk',
    name: 'produk',
    component: ProdukHukum
  },
  {
    path: '/foto',
    name: 'foto',
    component: Foto
  },
  {
    path: '/video',
    name: 'video',
    component: Video
  },
]

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    return {
      top: 0,
      behavior: 'smooth'
     }
  },
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
